(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
   var flkty1; 
  function initFlickitypdp() {
    var elem = document.querySelector('.press-section');
    if (elem) {
      if (flkty1) {
        flkty1.destroy();
      }
      flkty1 = new Flickity(elem, {
        prevNextButtons: true,
        pageDots: false,       
        cellAlign: 'left',       
        autoPlay: false,
        pauseAutoPlayOnHover: false,
        wrapAround: false,
        friction: 0.5,            
        contain: true,      
    on: {
        ready: function() {
            this.off( 'uiChange', this.stopPlayer );
            this.off( 'pointerDown', this.stopPlayer );
            elem.classList.add("loaded");
          }
        }
      });
    }
  }
  initFlickitypdp(); 
  window.onload = function () {
  initFlickitypdp();
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-routine"] && !Shopify.designMode) return;
  try {
    
  function initRoutineSwitch(block) {
    const parent = block.querySelector('.crrtn-sec__body'); 
    if (! parent) return;

    const switcher = parent.querySelector('.p-switch input');
    const switchHandler = function() {
      if (switcher.checked) {
        parent.classList.add('crrtn-sec__body--pm');
      } else {
        parent.classList.remove('crrtn-sec__body--pm');
      }
    }
    switchHandler();
    switcher.addEventListener('change', switchHandler);    
  }

  document.addEventListener("DOMContentLoaded", (event) => { 
    const blocks =  document.querySelectorAll('.crrtn-sec');
    for(let i = 0; i < blocks.length; i++) {
      initRoutineSwitch(blocks[i]); 
    }      
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const chatLinks = document.querySelectorAll(".contact-sec__item-btn--chat-link")
    
    chatLinks.forEach(link => {
      const mobileLink = link.dataset.mobileLink
      const desktopLink = link.dataset.desktopLink

      // Basic mobile detection using userAgent
      const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

      if (isMobile && mobileLink) {
        link.href = mobileLink
      } else {
        link.href = desktopLink
      }
    })
  })
  //Thanks for contacting us. We'll get back to you as soon as possible. 
  //clean form success before form
  document.addEventListener("globo.formbuilder.form.submitted", (event) => {     
    console.log("globo.formbuilder.form.submitted", event);
    const det = event.detail;
     if (! det.form) {
      return;
     }
     if ((det.response.length > 0) && (det.response[0].success == 'true')) {
      const parent = det.form.closest('.contact-sec__form-wrap');
      if (! parent) {
          return;
      }
      const msg = parent.querySelector('.contact-sec__form-result');
      console.log(parent, msg);
      msg.classList.add('contact-sec__form-result--active');
     }
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emmy-feature-slider"] && !Shopify.designMode) return;
  try {
    
  var emmyFlkty; 
  function initEmmyFlickity() {
    var elemEmmy = document.querySelector('.emmy-banner-image-slider');
    if (elemEmmy) {
      if (emmyFlkty) {
        emmyFlkty.destroy();
      }
      emmyFlkty = new Flickity(elemEmmy, {
        prevNextButtons: true,
        pageDots: true,
        cellAlign: 'left',
        contain: false,
        autoPlay: false,
        wrapAround: false,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z',
        pauseAutoPlayOnHover: false,
        
        on: {
          ready: function() {
            this.off('uiChange', this.stopPlayer);
            this.off('pointerDown', this.stopPlayer); 
            // console.log("Ready");
            elemEmmy.classList.add("loaded");
          }
        }
      });
    }
  }
  initEmmyFlickity(); 
  window.onload = function () {
    initEmmyFlickity();
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emmys-giving-suite"] && !Shopify.designMode) return;
  try {
      
  
  function initEmGivsBlock(block) {
    const holder = block.querySelector('.em-givs__items');
    const slides = block.querySelectorAll('.em-givs__item');
    if ((! holder) || (slides.length == 0)) {
      return;
    } 
    let isSlider = false;
    let flickity = null;
    const media = matchMedia('screen and (max-width: 450px)'); 
    const initFlickity = function(){
      flickity = new Flickity( holder, {
        prevNextButtons: false,
        cellAlign: 'left',
        groupCells: false,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: false,
        autoPlay: false,
        pauseAutoPlayOnHover: false,
        adaptiveHeight: false,
        cellSelector: '.em-givs__item',
        selectedAttraction: 0.05,
        wrapAround: false,
        friction: 0.5,
        adaptiveHeight: true,        
      } );
      isSlider = true;
    }

    if (media.matches) {
      initFlickity();
    }
    
    window.addEventListener("resize", function() {
      if (media.matches) {
        if (! isSlider) {
          initFlickity();
        }
      } else {
        if (isSlider) {
          isSlider = false;
          if (flickity) {
            flickity.destroy()
          }
        }
      }
    });
    
  }
  document.addEventListener("DOMContentLoaded", (event) => {
      const blocks =  document.querySelectorAll('.em-givs');
      for(let i = 0; i < blocks.length; i++) {
        initEmGivsBlock(blocks[i]); 
      }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;

      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
  document.addEventListener("globo.formbuilder.form.submitted", (event) => { 
    const det = event.detail;
     if (! det.form) {
      return;
     }
     if ((det.response.length > 0) && (det.response[0].success == 'true')) {
      const parent = det.form.closest('.footer-block__newsletter');
      if (! parent) {
          return;
      }
      const msg = parent.querySelector('.footer-block__newsletter-msg');      
      msg.classList.add('footer-block__newsletter-msg--active');
     }
    
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
      //this.toggleBtn = this.header.querySelector('header-menu-toggle');
      //this.toggleBtn.addEventListener('click', this.onButtonClick.bind(this));
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.toggleBtn.removeEventListener('click', this.onButtonClick);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;        
        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          }; 
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {                                                                                    
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) { 
            requestAnimationFrame(this.reveal.bind(this));
          }
          else { 
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) { 
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return; 
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) { 
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() { 
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
    //togge Btn
    onButtonClick(event) {
      event.stopPropagation(); 
      event.preventDefault(); 
      this.header.classList.toggle('shopify-section-header-menu-open');      
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader); 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !Shopify.designMode) return;
  try {
      
  document.addEventListener("DOMContentLoaded", (event) => {
        if (! window.initMobSlidersBlockFunc)  {
        return;
      } 
      const medias =  document.querySelectorAll('.htu-sec');
      for(let i = 0; i < medias.length; i++) {
        initMobSlidersBlockFunc( medias[i], '767', '.htu-sec__imgs', '.htu-sec__imgs-item'); 
        
      }
      
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
      
  
  // function initSlidersBlock(block, itemsSelector, slideSelector, centerClass) {
  //   const holder = block.querySelector(itemsSelector);
  //   const slides = block.querySelectorAll(slideSelector);
  //   if ((! holder) || (slides.length == 0)) {
  //     return;
  //   }
    
  //   let flickity = null;
  //   let cellAlign = 'left';
  //   // if ((centerClass) && (holder.classList.contains(centerClass))) {
  //   //   cellAlign = 'center';
  //   // }
    
  //   const initFlickity = function(){
  //     flickity = new Flickity( holder, {
  //       prevNextButtons: false,
  //       cellAlign: cellAlign,
  //       groupCells: false,
  //       imagesLoaded: true,
  //       pageDots: false,
  //       percentPosition: false,
  //       autoPlay: false,
  //       pauseAutoPlayOnHover: false,
  //       adaptiveHeight: false,
  //       cellSelector: slideSelector,
  //       selectedAttraction: 0.05,
  //       wrapAround: false,
  //       friction: 0.5, 
  //       contain: true           
  //     } );      
  //   }
  //   initFlickity();
      
    
    
  // }
  document.addEventListener("DOMContentLoaded", (event) => {
        if (! window.initMobSlidersBlockFunc)  {
        return;
      } 
      const medias =  document.querySelectorAll('.ingr-sec');
      for(let i = 0; i < medias.length; i++) {
        initMobSlidersBlockFunc(medias[i], '1200', '.ingr-sec__items', '.ingr-sec__item'); 
        //initSlidersBlock(medias[i], '.ingr-sec__items', '.ingr-sec__item', 'ingr-sec__items--short'); 
      }
      
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", (event) => {
  if (! window.initMobSlidersBlockFunc)  {
    return;
  } 
  const blocks =  document.querySelectorAll('.sgal-sec');
  for(let i = 0; i < blocks.length; i++) {
    initMobSlidersBlockFunc(blocks[i], '1024', '.sgal-sec__items', '.sgal-sec__item'); 
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list-slider"] && !Shopify.designMode) return;
  try {
    
  
  var flkty; 
  function initFlickity() {
    var elem = document.querySelector('.logo-slider');
    if (elem) {
      if (flkty) {
        flkty.destroy();
      }
      flkty = new Flickity(elem, {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        autoPlay: true,
        wrapAround: false,
        pauseAutoPlayOnHover: false,
    on: {
        ready: function() {
            this.off( 'uiChange', this.stopPlayer );
            this.off( 'pointerDown', this.stopPlayer ); 
            console.log("REady");
            elem.classList.add("loaded");
          }
        }
      });
    }
  }
  initFlickity(); 
  window.onload = function () {
  initFlickity();
  };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["may-like"] && !Shopify.designMode) return;
  try {
      
  
  function initMobSlidersBlock(block, mediaSize, itemsSelector, slideSelector) {
    const holder = block.querySelector(itemsSelector);
    const slides = block.querySelectorAll(slideSelector);
    if ((! holder) || (slides.length == 0)) {
      return;
    } 
    let isSlider = false;
    let flickity = null;
    const media = matchMedia('screen and (max-width: ' + mediaSize +'px)');   
    const initFlickity = function(){
      flickity = new Flickity( holder, {
        prevNextButtons: false,
        cellAlign: 'left',
        groupCells: false,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: false,
        autoPlay: false,
        pauseAutoPlayOnHover: false,
        //adaptiveHeight: false,
        cellSelector: slideSelector,
        selectedAttraction: 0.05,
        wrapAround: false,
        friction: 0.5,
        adaptiveHeight: true, 
        contain: true        
      } );
      isSlider = true;
    }

    if (media.matches) {
      initFlickity();
    }
    
    window.addEventListener("resize", function() {
      if (media.matches) {
        if (! isSlider) {
          initFlickity();
        }
      } else {
        if (isSlider) {
          isSlider = false;
          if (flickity) {
            flickity.destroy()
          }
        }
      }
    });
    
  }
  document.addEventListener("DOMContentLoaded", (event) => {
     
      const likes =  document.querySelectorAll('.may-like');
      for(let i = 0; i < likes.length; i++) {
        initMobSlidersBlock(likes[i], '767', '.may-like__items', '.may-like__item'); 
      }

      const discountItem = document.querySelectorAll('.may-like__item[data-discount]');
      
      discountItem.forEach((item) => {
          const discount = item.getAttribute('data-discount');
          const priceCard = item.querySelector('.price-card');
          const priceWrap = item.querySelector('.price__regular price-money');
          const price = parseFloat(priceWrap.textContent.split('$')[1]);
          const discountPrice = Math.round((price - (price * discount / 100)) * 100) / 100;
          const discountPriceArray = discountPrice.toString().split('.');

          priceCard.classList.add('price--on-sale');
          priceCard.querySelector('.price__sale dd.price__compare price-money').innerHTML = '<bdi><span class="price__prefix">$</span>' + price + '<sup class="price__suffix">.00</sup></bdi>';
          priceCard.querySelector('.price__sale dd.price__last price-money').innerHTML = '<bdi><span class="price__prefix">$</span>' + discountPriceArray[0] + '<sup class="price__suffix">.' + discountPriceArray[1] + '</sup></bdi>';
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prefooter-home"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", (event) => {
  if (! window.initMobSlidersBlockFunc)  {
    return;
  } 
  const blocks =  document.querySelectorAll('.sgal-sec');
  for(let i = 0; i < blocks.length; i++) {
    initMobSlidersBlockFunc(blocks[i], '1024', '.sgal-sec__items', '.sgal-sec__item'); 
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prefooter-product"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", (event) => {
  if (! window.initMobSlidersBlockFunc)  {
    return;
  } 
  const blocks =  document.querySelectorAll('.sgal-sec');
  for(let i = 0; i < blocks.length; i++) {
    initMobSlidersBlockFunc(blocks[i], '1024', '.sgal-sec__items', '.sgal-sec__item'); 
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-content"] && !Shopify.designMode) return;
  try {
      
  function initUgcBlock(block) {
    const holder = block.querySelector('.ugc-sec__items');
    const slides = block.querySelectorAll('.ugc-sec__item');
    if ((! holder) || (slides.length == 0)) {
      return;
    }
    const videos = [];

    /*
      FND-78 - this row was a Flickity carousel below 1200px. Flickity ran with
      no arrows, no dots, no autoplay and no wrapAround, on a breakpoint only
      touch devices reach, where the browser drags natively anyway - and it
      marked off-screen cells aria-hidden while leaving them focusable, so the
      keyboard entered cards no screen reader could see.

      It is now CSS scroll-snap (see section-ug-content.scss). No hidden cells,
      so nothing to hide from the keyboard and no shim to keep in sync. The
      container gets its tabindex from `scrollable-regions.js` while it overflows.
    */

    const pauseAllVideos = function(video) {
      for(let i = 0; i < videos.length; i++) { 
        if(video && (video == videos[i].video)) {
          
          continue;
        }
        videos[i].pause();
      }
    }

    const initVideo = function(item) {
      const video = item.querySelector('.ugc-sec__item-media video');
      const btn = item.querySelector('.ugc-sec__item-play'); 
      const sound = item.querySelector('.ugc-sec__item-sound');
      const syncState = function(playing) {
        btn.classList.toggle('ugc-sec__item-play--active', playing);
        btn.setAttribute('aria-label', playing ? btn.dataset.labelPause : btn.dataset.labelPlay);
      }

      const play = function() {
        if (! video.paused) {
          return;
        }
        video.play();
        syncState(true);
      }

      const pause = function() {
        if (video.paused) {
          return;
        }
        video.pause();
        syncState(false);
      }

      // The video can also stop on its own - another tile taking over, the tab going
      // to the background - so the name follows the media, not just the click.
      video.addEventListener('play', function() { syncState(true); });
      video.addEventListener('pause', function() { syncState(false); });

      btn.addEventListener('click', function(){
        // console.log(btn);
        if (video.paused) {
          pauseAllVideos(video);
          play();
        } else {
          pause();
        }
      });

      // let isMuted = true;
      // sound.addEventListener('click', function(){
      //   if (isMuted) {
      //     video.removeAttribute('muted');
      //     video.muted = false;          
      //     isMuted = false;
      //   }
      //   if ((video.volume == 0) || (! sound.classList.contains('ugc-sec__item-sound--active'))) {
      //     sound.classList.add('ugc-sec__item-sound--active'); 
      //     video.volume = 1;
      //   } else {
      //     sound.classList.remove('ugc-sec__item-sound--active'); 
      //     video.volume = 0;
      //   }
      // });

      return {
        video: video,
        btn: btn,
        play: play,
        pause: pause
      };
    }
     
    for(let i = 0; i < slides.length; i++) {
      videos.push(initVideo(slides[i]));
    }

    let isVisible = false; 
    // let isMuted = true;

    const isInViewport = function () {
      const rect = holder.getBoundingClientRect();
      const html = document.documentElement;
      const pageBottom = (window.innerHeight || html.clientHeight);
      return (
        rect.top >= 0 &&        
        rect.bottom <= (window.innerHeight || html.clientHeight) 
      );
    }

    document.addEventListener( 'scroll', () => {
      const status = isInViewport();
      if (status == isVisible) return;
      if (status) {
        videos[0].play();
        // if (isMuted) {
        //   for(let i = 0; i < videos.length; i++) { 
        //     videos[i].video.removeAttribute('muted');
        //     videos[i].video.muted = false;
        //     videos[i].video.volume = 1;
        //   }
        //   isMuted = false;
        // }
      } else {
        pauseAllVideos(null);
      }
      isVisible = status;      
  } );
    
  }
  document.addEventListener("DOMContentLoaded", (event) => {
      const blocks =  document.querySelectorAll('.ugc-sec');
      for(let i = 0; i < blocks.length; i++) {
        initUgcBlock(blocks[i]); 
      }
  });


  } catch(e) { console.error(e); }
})();
})();
